import { QuestionCircleOutlined } from '@ant-design/icons'
import { Flex, Tooltip } from 'antd'
import { ReactNode } from 'react'
import { UiText } from 'src/pages/budget/components/uiText'

type Props = {
  children: ReactNode
  hint: ReactNode
}

export const FieldLabel = ({ children, hint }: Props) => (
  <Flex align="center" gap={6}>
    <UiText size={18}>{children}</UiText>

    <Tooltip
      title={<span style={{ whiteSpace: 'pre-line' }}>{hint}</span>}
      trigger={['hover', 'focus']}
      styles={{ root: { maxWidth: 450 } }}
    >
      <QuestionCircleOutlined
        tabIndex={0}
        style={{
          color: 'var(--crm-text-secondary)',
          cursor: 'help',
          fontSize: 16,
        }}
      />
    </Tooltip>
  </Flex>
)
